<template>
  <div id="app" class="min-h-screen flex overflow-auto">
    <Nav class="hidden md:block" :menu-list-item="menuListItems" :user="user" style="height: 100vh;"></Nav>
    <header class="bg-white flex justify-between px-2 lg:px-20">
      <Nav class="md:hidden" mode="mobile" :menu-list-item="menuListItems" :user="user"></Nav>
      <a class="flex items-center" style="margin: auto;" href="javascript:void(0)" @click="goHome()">
        <img alt="Zinger" src="../assets/logo.png" height="49" width="108">
        <!-- <span class="ml-3">Zinger</span> -->
      </a>
      <div class="flex items-center">
        <!-- <Button @click.native="openSideBar"
                class="mx-2 relative text-gray-1 hover:text-primary-normal"
                round>
          <span class="absolute top-0 right-0 h-2 w-2 rounded-full bg-primary-normal"></span>
          <svg xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               height="35"
               width="35"
               class="fill-current">
            <use xlink:href="#c-icon-bell"></use>
          </svg>
        </Button>
        <Button @click.native="openSideBar"
                class="mx-2 relative text-gray-1 hover:text-primary-normal"
                round>
          <span class="absolute top-0 right-0 h-2 w-2 rounded-full bg-primary-normal"></span>
          <svg xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink"
               height="35"
               width="35"
               class="fill-current">
            <use xlink:href="#c-icon-chat"></use>
          </svg>
        </Button> -->
        <Button @click.native="openSideBar"
                class="mx-2 chout"
                round>
          <avatar type="simple"
                  :img="user.img"
                  img-class="h-8 w-8 rounded-full">
          </avatar>
        </Button>
      </div>
    </header>
    <router-view class="min-h-full nextt" />
    <SideBar :is-visible="isOpenSideBar"></SideBar>
    <!-- Staff Modal -->
    <modal name="staffModal" :adaptive="true" width="620" :styles="{'background': '#EAFAF1', 'border-radius': '20px'}">
      <div id="staff-list" class="tvv" :style="isLoadingStaff || isLoadingStaffMore ? 'justify-content: center; align-items: center; text-align: center;' : ''">
        <img id="rtt" src="../assets/img/loaders/loading.svg" alt="" width="64" height="64" style="text-align: center;" v-if="isLoadingStaff">
        <Button @click.native="makePrimaryAccountMain"
                class="mx-2 chout"
                round
                style="padding: 2rem; display: flex; flex-direction: column; align-items: center;"
                v-if="!isLoadingStaff">
          <avatar type="simple"
                  :img="user.img"
                  img-class="h-16 w-16 rounded-full"
                  style="text-align: center;">
          </avatar>
          <h5 style="padding-left: -2rem;">@{{ username }} (Main)</h5>
        </Button> 
        <Button @click.native="makePrimaryAccount(item)"
                class="mx-2 chout"
                round
                style="padding: 2rem; display: flex; flex-direction: column; align-items: center;"
                v-for="(item,index) in jobs" :key="index">
          <avatar type="simple"
                  :img="{src: item.business.profile.profile_pic, alt: 'avatar'}"
                  img-class="h-16 w-16 rounded-full"
                  style="text-align: center;">
          </avatar>
          <h5 style="padding-left: -2rem;">{{ item.business.profile.business_name }}</h5>
        </Button> 
        <img id="rtt" src="../assets/img/loaders/loading.svg" alt="" width="24" height="24" style="text-align: center;" v-if="isLoadingStaffMore">
      </div>
    </modal>
    <ModalIdle v-if="isIdle" />
  </div>
</template>

<script>
  import router from "../router";
  import Nav from '../components/Nav';
  import Button from "../components/Button";
  import Avatar from "../components/Avatar";
  import SideBar from "../components/SideBar";
  // import axios from "axios";
  import axios from '../AxiosInstance.js';
  import ModalIdle from "@/components/ModalIdle";
  // import io from "socket.io-client";

  export default {
    name: 'default',
    components: {
      Nav,
      Button,
      Avatar,
      SideBar,
      ModalIdle,
    },
    computed: {
      isIdle() {
        return this.$store.state.idleVue.isIdle;
      },
    },
    data () {
      return {
        menuListItems: localStorage.getItem('is_business') == 'false' ? [
          {
            id: 0,
            icon: "#c-icon-dashboard",
            title: "Overview",
            url: "/"
          },
          {
            id: 1,
            icon: "#c-icon-analytics",
            title: "Transactions",
            url: "/transactions"
          },
          {
            id: 2,
            icon: "#c-icon-bills",
            title: "Bill Payments",
            url: "/bills"
          },
          {
            id: 3,
            icon: "#c-icon-stash",
            title: "Stash",
            url: "/stash"
          },
          {
            id: 4,
            icon: "#c-icon-credit-card",
            title: "Cards",
            url: "/cards"
          },
          localStorage.getItem('is_signatory') == 'true' ? {
            id: 5,
            icon: "#c-icon-chat",
            title: "Approvals",
            url: "/signatory-approvals"
          }:{},
          {
            id: 6,
            icon: "#c-icon-transfer",
            title: "Transfer",
            url: "/transfer"
          },
          {
            id: 7,
            icon: "#c-icon-voucher",
            title: "Vouchers",
            url: "/vouchers"
          },
          {
            id: 8,
            icon: "#c-icon-chat-2",
            title: "Support",
            url: "/support"
          }
        ] 
	: [
          {
            id: 0,
            icon: "#c-icon-dashboard",
            title: "Overview",
            url: "/"
          },
          {
            id: 1,
            icon: "#c-icon-analytics",
            title: "Transactions",
            url: "/transactions"
          },
          {
            id: 2,
            icon: "#c-icon-pos",
            title: "POS",
            url: "/pos"
          },
          {
            id: 3,
            icon: "#c-icon-ticket",
            title: "Subscriptions",
            url: "/bundles"
          },
          {
            id: 4,
            icon: "#c-icon-bills",
            title: "Bill Payments",
            url: "/bills"
          },
          {
            id: 5,
            icon: "#c-icon-stash",
            title: "Stash",
            url: "/stash"
          },
          {
            id: 6,
            icon: "#c-icon-credit-card",
            title: "Cards",
            url: "/cards"
          },
          {
            id: 7,
            icon: "#c-icon-customer",
            title: "Customers",
            url: "/customers"
          },
          {
            id: 8,
            icon: "#c-icon-staff",
            title: "Signatories",
            url: "/signatories"
          },
          {
            id: 9,
            icon: "#c-icon-chat",
            title: "Approvals",
            url: "/approvals"
          },
          {
            id: 10,
            icon: "#c-icon-staff",
            title: "Staff",
            url: "/staff"
          },
          {
            id: 11,
            icon: "#c-icon-depts",
            title: "Departments",
            url: "/departments"
          },
          {
            id: 12,
            icon: "#c-icon-transfer",
            title: "Transfer",
            url: "/transfer"
          },
          {
            id: 13,
            icon: "#c-icon-voucher",
            title: "Vouchers",
            url: "/vouchers"
          },
          {
            id: 14,
            icon: "#c-icon-chat-2",
            title: "Support",
            url: "/support"
          }
        ],
        url: process.env.VUE_APP_BASE_URL,
        // socket: io(process.env.VUE_APP_NODE_URL),
        user: {
          img: {
            src: localStorage.getItem("profile_pic"),
            alt: 'avatar'
          },
          firstName: localStorage.getItem("first_name") == '' ? localStorage.getItem("business_name") : localStorage.getItem("first_name") ,
          username: localStorage.getItem("staff_username") ? localStorage.getItem("staff_username") : localStorage.getItem("username"),
          professionnalFunction: "Customer",
          businessName: localStorage.getItem("business_name")
        },
        token:this.decrypt(localStorage.getItem("token")),
        user_id:this.decrypt(localStorage.getItem("user_id")),
        username: localStorage.getItem("username"),
        isOpenSideBar: false,
        isLoadingStaff: false,
        limit: 6,
        busy: false,
        isLoadingStaffMore: false,
        jobs: [],
        nextPage: null,
        soc_date: null,
        soc_date2: null,
        n_date: null,
      }
    },
    sockets: {
      connect() {
        // Fired when the socket connects.
        // console.log('socket connected')
        // this.$root.$emit('connect-socket-bal-trans', true);
      },

      disconnect() {
        // console.log('socket disconnected')
        // this.isConnected = false;
      }, 
 
      // Fired when the server sends something on the "messageChannel" channel.
      transaction(data) {
        // console.log(data);
        if(this.soc_date != data.transaction.date){
          if(data.transaction.receiver == this.user_id || data.transaction.rec_business == this.user_id){
            this.soc_date = data.transaction.date;
            this.$root.$emit('socket-new-trans', data.transaction);
          }
        }
        // this.socketMessage = data
      },

      topup(data) {
        if(this.soc_date != data.date){
          if(data.receiver == this.user_id){
            this.soc_date = data.date;
            this.$root.$emit('connect-socket-bal-trans2', true);
          }
        }
        // this.socketMessage = data
      },

      bankTr(data) {
        if(this.soc_date != data.date){
          if(data.receiver == this.user_id || data.rec_business == this.user_id){
            this.soc_date = data.date;
            this.$root.$emit('connect-socket-bal-trans3', true);
          }
        }
        // this.socketMessage = data
      },

      voucher(data) {
        // console.log('hereq')
        if(this.soc_date2 != data.voucher.date){
          if(data.voucher.voucher_given_user_id == this.user_id){
            // console.log('here2')
            this.soc_date2 = data.voucher.date;
            this.$root.$emit('connect-socket-bal-trans', true);
            this.$root.$emit('vch', true);
            this.$toast.info(data.voucher.business_giving_voucher_name + ' just gave you a voucher', {duration: 10000, position: "top-right"});
          }
        }
        // this.socketMessage = data
      }
    },
    beforeDestroy () {
    },
    mounted(){
      // console.log(this.$socket);
      this.$root.$on("newTrans", (text) => {
        if(this.n_date != text.date){
          this.n_date = text.date;
          // console.log('hhhhoo')
          this.$socket.client.emit("new_transaction", {
            transaction: text,
          });
        }
      });
      this.$root.$on("newVoucher", (text) => {
        if(this.n_date != text.date){
          this.n_date = text.date;
          // console.log('hhhhoo')
          this.$socket.client.emit("new_voucher", {
            voucher: text,
          });
        }
      });
      this.$root.$on("profile-update", () => {
        this.user.img.src = localStorage.getItem("profile_pic");
        if(localStorage.getItem("first_name") == ''){
          this.user.firstName = localStorage.getItem("business_name");
        }else{
          this.user.firstName = localStorage.getItem("first_name");
        }
        if(localStorage.getItem("staff_username")){
          this.user.username = localStorage.getItem("staff_username");
        }else{
          this.user.username = localStorage.getItem("username");
        }
        this.username = localStorage.getItem("username");
        this.user.businessName = localStorage.getItem("business_name");
      });
      
      this.$root.$on("newStaffTrans", (text) => {
        this.$socket.client.emit("new_transaction", {
          transaction: text,
        });
      });
      this.$root.$on("closeOtherModals", () => {
        this.isOpenSideBar = false;
        this.$modal.show('staffModal');
        this.getStaff();
      });
      this.$root.$on("closeOtherModals2", () => {
        this.isOpenSideBar = false;
      });
      if(localStorage.getItem("on_business_name")){
        this.menuListItems = [
          {
            id: 0,
            icon: "#c-icon-dashboard",
            title: "Overview",
            url: "/"
          },
          {
            id: 1,
            icon: "#c-icon-analytics",
            title: "Transactions",
            url: "/transactions"
          },
          {
            id: 7,
            icon: "#c-icon-chat-2",
            title: "Support",
            url: "/support"
          }
        ];
      }
    },
    methods: {
      openSideBar () {
        this.isOpenSideBar = !this.isOpenSideBar;
      },
      goHome(){
        // console.log(router.currentRoute.path)
        if(router.currentRoute.path != "/"){
          router.push("/");
        }
      },
      getStaff(){
        this.isLoadingStaff = true;
        axios.get(this.url + "api/v1/staff-staffs/" + this.user_id + "/",
        { headers: { authorization: "Token " +this.token} }).then(response => {
          this.isLoadingStaff = false;
          this.jobs = response.data.results;
          this.nextPage = response.data.links.next;
          // console.log(response)
          const listElm = document.querySelector('#staff-list');
          if(listElm){
            listElm.addEventListener('scroll', e => {
                if(listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                    this.getMoreJobs();
                }
            });
          }
        }).catch(err => {
          this.isLoadingStaff = false;
          this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
        })
      },
      getMoreJobs(){
        // console.log('here')
        if(this.nextPage != null){
            this.isLoadingStaffMore = true;
            axios.get(this.nextPage,
            { headers: { authorization: "Token " +this.token} }).then(response => {
                this.jobs = [...this.jobs,...response.data.results];
                if(response.data.links.next != null){
                    this.nextPage = response.data.links.next;
                }else{
                    this.nextPage = null;
                }
                this.isLoadingStaffMore = false;
            }).catch(err => {
                this.isLoadingStaffMore = false;
                this.$toast.error('Error. Please check your connection.', {duration: 3000, position: "top-right"});
            });
        }
      },
      makePrimaryAccount(item){
        this.$modal.hide('staffModal');
        localStorage.setItem("on_staff", 'true');
        localStorage.setItem("on_business_name", item.business.profile.business_name);
        localStorage.setItem("on_business_id", item.business.id);
        localStorage.setItem("staff_username", item.staff_username);
        localStorage.setItem("staffId", item.id);
        if(item.is_boss){
          localStorage.setItem("deptss_id", item.department);
        }else{
          localStorage.removeItem("deptss_id");
        }
        this.$root.$emit("updateStaff", item);
        this.user.username = item.staff_username;
        this.menuListItems = [
          {
            id: 0,
            icon: "#c-icon-dashboard",
            title: "Overview",
            url: "/"
          },
          {
            id: 1,
            icon: "#c-icon-analytics",
            title: "Transactions",
            url: "/transactions"
          },
          {
            id: 7,
            icon: "#c-icon-chat-2",
            title: "Support",
            url: "/support"
          }
        ];
        this.goHome();
        this.$toast.success('Account Changed', {duration: 3000, position: "top-right"});
      },
      makePrimaryAccountMain(){
        this.$modal.hide('staffModal');
        this.$root.$emit("updateStaffMain");
        localStorage.setItem("on_staff", 'false');
        localStorage.removeItem("on_business_name");
        localStorage.removeItem("on_business_id");
        localStorage.removeItem("staff_username");
        localStorage.removeItem("staffId");
        localStorage.removeItem("deptss_id");
        this.user.username = localStorage.getItem("username");
        this.menuListItems = localStorage.getItem('is_business') == 'false' ? [
          {
            id: 0,
            icon: "#c-icon-dashboard",
            title: "Overview",
            url: "/"
          },
          {
            id: 1,
            icon: "#c-icon-analytics",
            title: "Transactions",
            url: "/transactions"
          },
          {
            id: 2,
            icon: "#c-icon-bills",
            title: "Bill Payments",
            url: "/bills"
          },
          {
            id: 3,
            icon: "#c-icon-stash",
            title: "Stash",
            url: "/stash"
          },
          {
            id: 4,
            icon: "#c-icon-credit-card",
            title: "Cards",
            url: "/cards"
          },
          localStorage.getItem('is_signatory') == 'true' ? {
            id: 5,
            icon: "#c-icon-chat",
            title: "Approvals",
            url: "/signatory-approvals"
          }:{},
          {
            id: 6,
            icon: "#c-icon-transfer",
            title: "Transfer",
            url: "/transfer"
          },
          {
            id: 7,
            icon: "#c-icon-voucher",
            title: "Vouchers",
            url: "/vouchers"
          },
          {
            id: 8,
            icon: "#c-icon-chat-2",
            title: "Support",
            url: "/support"
          }
        ] 
	: [
          {
            id: 0,
            icon: "#c-icon-dashboard",
            title: "Overview",
            url: "/"
          },
          {
            id: 1,
            icon: "#c-icon-analytics",
            title: "Transactions",
            url: "/transactions"
          },
          {
            id: 2,
            icon: "#c-icon-pos",
            title: "POS",
            url: "/pos"
          },
          {
            id: 3,
            icon: "#c-icon-ticket",
            title: "Subscriptions",
            url: "/bundles"
          },
          {
            id: 4,
            icon: "#c-icon-bills",
            title: "Bill Payments",
            url: "/bills"
          },
          {
            id: 5,
            icon: "#c-icon-stash",
            title: "Stash",
            url: "/stash"
          },
          {
            id: 6,
            icon: "#c-icon-credit-card",
            title: "Cards",
            url: "/cards"
          },
          {
            id: 7,
            icon: "#c-icon-customer",
            title: "Customers",
            url: "/customers"
          },
          {
            id: 8,
            icon: "#c-icon-staff",
            title: "Signatories",
            url: "/signatories"
          },
          {
            id: 9,
            icon: "#c-icon-chat",
            title: "Approvals",
            url: "/approvals"
          },
          {
            id: 10,
            icon: "#c-icon-staff",
            title: "Staff",
            url: "/staff"
          },
          {
            id: 11,
            icon: "#c-icon-depts",
            title: "Departments",
            url: "/departments"
          },
          {
            id: 12,
            icon: "#c-icon-transfer",
            title: "Transfer",
            url: "/transfer"
          },
          {
            id: 13,
            icon: "#c-icon-voucher",
            title: "Vouchers",
            url: "/vouchers"
          },
          {
            id: 14,
            icon: "#c-icon-chat-2",
            title: "Support",
            url: "/support"
          }
        ];
        this.goHome();
        this.$toast.success('Account Changed', {duration: 3000, position: "top-right"});
      },
    }
  }
</script>

<style>
  .nextt{
    padding: 20px 25px 0;
    border-radius: 20px;
    box-shadow: -1px 3px 12px #F7F9F9;
    background: #EAFAF1;
  }
  .tvv{
    display: flex; 
    flex-wrap: wrap; 
    flex-direction: row;
    align-items: flex-start;
    text-align: left; 
    height: 300px; 
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 10px;
    scroll-behavior: smooth;  
  }
  .chout:focus{
    outline-width: 3px;
    outline-color: #2ECC71;
  }
  *:focus{
    outline-color: #2ECC71;
  }
  html, body{
    margin: 0;
    overflow: hidden !important;
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    display: grid;
    background-color: #ffffff;
    grid-template-columns: 100%;
    grid-template-rows: 1fr;
    grid-template-areas: "head"
    "main";
  }
  #app > header {
    grid-area: head;
  }
  main {
    grid-area: main;
  }

  @media (min-width: 768px) {
    #app {
      grid-template-columns: auto 1fr;
      grid-template-rows: 80px 1fr ;
      grid-template-areas: "nav head"
      "nav main";
    }

    #app > header {
      grid-area: head;
    }
  }

  @keyframes spin {
      0% { transform: rotate(0deg); }
      100% {  transform: rotate(359deg); }
  }
  #rtt {
      animation: spin 2s linear infinite;

  }
</style>
